import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';
import { IWorkbookRevision } from '../types/IWorkbookRevision';

export interface IGetWorkbookVersionsParams extends IGetItemsParams {
}

export interface IGetWorkbookVersionsResult extends IGetItemsResult {
  versions: IWorkbookRevision[];
}

export class GetWorkbookVersionsRequest extends Request<IGetWorkbookVersionsParams, IGetWorkbookVersionsResult> {
  constructor(params: IGetWorkbookVersionsParams) {
    super('getWorkbookVersions', params);
  }
}
